import { useMemo } from 'react'
import useSWR from 'swr'

import { YieldTokenConfig } from '../constants/yield'
import { fetchYieldStats } from '../utils/yield'

export default function useYieldStats(config: YieldTokenConfig) {
  const { data: allStats, ...props } = useSWR(['YieldStats'], fetchYieldStats, {
    revalidateOnFocus: false,
    keepPreviousData: true,
  })

  const stats = allStats ? allStats[config.id] : undefined

  return useMemo(
    () => ({
      data: stats,
      ...props,
    }),
    [stats, props]
  )
}
